import {HINTS_URL} from './api';

export const ECOMMERCE = true;
export const AGE_PROP_NAME = 'age';
export const LOCAL_PROP_NAME = 'props';

// export const GEO_SERVICE_API = '/api/v1.0/rest/ecommerce/geo';
export const GEO_SERVICE_API = `${HINTS_URL}/HintsService/v1.0/rest/ecommerce/geo`;
export const pollingInterval = 30000;
export const reconnectInterval = 30000;

// DELIVERY\ADDRESSES
export const DEFAULT_DELIVERY_RADIUS = 20000;
export const DEFAULT_CENTER_LAT = 37.6853373;
export const DEFAULT_CENTER_LNG = -122.09284860000002;



// WEBPACK FOOTER //
// ./src/config/global.js